/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FCS API
 * Field Compliance System — REST API
 * OpenAPI spec version: 0.0.54-SNAPSHOT
 */

export type ActionPlanStatus = typeof ActionPlanStatus[keyof typeof ActionPlanStatus];


export const ActionPlanStatus = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CLOSED: 'CLOSED',
} as const;
